module.exports = "<div id=injected-header> <header> <section class=\"top grid chart\"> </section> <section class=\"top grid\"> <div id=top_0_pnlLogo class=logo> <a id=top_0_hplLogo href=/ data-whld=tested> <img src=" + require("../assets/providence_new_logo.png") + " vspace=20 class=lo-res alt=\"Providence St. Joseph Health System\"> </a> </div> <section class=\"mobile-menu visible-mobile\"> <div> <a href=# class=nav-btn data-whld=tested></a> </div> </section> </section> </header> </div>";


//////////////////
// WEBPACK FOOTER
// ./includes/header.html
// module id = 13
// module chunks = 0